export default "__VITE_ASSET__Coo9tgBt__"